exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.statTotalPanel[data-v-fe26a108] {\n  border-top: 1px solid whitesmoke;\n  border-bottom: 1px solid whitesmoke;\n  height: 75px;\n}\n.visitorPanel[data-v-fe26a108] {\n  border-top: 1px solid whitesmoke;\n  height: 500px;\n}\n", ""]);

// exports
